import { WxShare } from './WxShare'

export const shareMgr = new WxShare()

// 获取分享链接
// 分享的链接参数：cityeId城市ID  redirectUrl跳转链接
/**
 *
 * @param {{cityId: string, redirectUrl: string, inviterUserId: string | undefined,inviterSessionId: string | undefined, operateActivityId: string | undefined,activityId: string | undefined  }} param0
 * @returns string
 */
export const getShareLink = ({
  cityId,
  redirectUrl,
  inviterUserId,
  inviterSessionId,
  ...extra
}) => {
  const { protocol, host, pathname } = window.location
  let str = ''
  Object.keys(extra || {}).forEach(key => {
    if (extra[key]) {
      str += `${key}=${extra[key]}&`
    }
  })
  str = str.substr(0, str.length - 1)

  const urlParamsStr = `inviterUserId=${inviterUserId}&inviterSessionId=${inviterSessionId}&${str}`
  let url = redirectUrl.includes('?')
    ? `${redirectUrl}&${urlParamsStr}`
    : `${redirectUrl}?${urlParamsStr}`
  url = encodeURIComponent(url)
  const link = `${protocol}//${host}${pathname}#/share-bridge?cityId=${cityId}&redirectUrl=${url}&${urlParamsStr}`
  // console.log('getShareLink link:', link)
  return link
}
